<div class="grid-row">
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8 tablet:grid-offset-2 desktop:grid-offset-2">
    <ul class="usa-card-group define-background">
      <li class="usa-card">
        <header class="usa-card__header text-center">
          <h2 class="usa-card__heading">Welcome to TMSS</h2>
        </header>
        <div class="usa-card__body">
          <p>
            Transportation Management Services Solution (TMSS) is the first comprehensive online household goods transportation management system designed exclusively for Federal civilian agencies.
          </p>
        </div>
      </li>
      </ul>
  </div>
</div>

<div class="grid-row padding-top-5">
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8 tablet:grid-offset-2 desktop:grid-offset-2">
    <ul class="usa-card-group define-background">
      <tabset #staticTabs>
        <tab heading="Overview">
          <div class="usa-card__body">
            <p>TMSS provides access to GSA's highly competitive transportation rates via the Centralized Household Goods Traffic Management Program (CHAMP). Average Savings - 8.5% off Commercial Rates. Strict TSP approval process. Over 250 TSPs.</p>
          </div>
        </tab>
        <tab heading="Placeholder">
          <div class="usa-card__body">Placeholder text here...</div>
        </tab>
      </tabset>
    </ul>
  </div>
</div>

<div class="padding-top-5"></div>

<h1 *ngIf="showError === 'false'" style="color: #8b0000">User does not exist, please login through SSO/OKTA</h1>
<div class="row" style="text-align: center">
  <div class="col">
    <button type="button"   routerLink="/signon" class="usa-button">Sign in </button>
  </div>
    
    <!-- <div class="col-6 col-sm-3"> <button type="button"  class="btn btn-primary btn-lg">  Sign in with SSO </button></div>
    <div class="col-6 col-sm-3"><button type="button"  class="btn btn-primary btn-lg">  Sign in with OKTA </button></div> -->
</div>

<div class="padding-bottom-5"></div>